// DS7.4.1, but this only the root layout.
import React from 'react';
import c from 'classnames';
import isArray from 'lodash/isArray';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './BannerLayout.scss';
/**
 * Takes an array of ReactNodes or an individual ReactNode and will wrap the latter in an array for
 * a more standard interface. This avoids nasty ternaries in the body of the below layout component.
 */ function nodesToArrayOrUndefined(nodes) {
    if (nodes === undefined) {
        return nodes;
    }
    if (isArray(nodes)) {
        return nodes;
    }
    return [
        nodes
    ];
}
/**
 * DS7.4.1, but only the layout. Use this in tandem with other {@link @wix/da-ds/pkg/Banner/lego} components when
 * building a variant of DS7.4.1
 */ const BannerLayout = ({ size, body, postfix, className, bodyClassName })=>{
    const bodyArray = nodesToArrayOrUndefined(body);
    const postfixArray = nodesToArrayOrUndefined(postfix);
    return /*#__PURE__*/ React.createElement("aside", {
        className: c(s['root'], s[size], className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: c(s['body-wrapper'], bodyClassName)
    }, // A `bodyArray &&` here to appease typescript. Never should be undefined.
    bodyArray && bodyArray.map((node, index)=>/*#__PURE__*/ React.createElement("div", {
            key: `body-${index}`,
            className: s['body-node']
        }, node))), postfixArray && postfixArray.map((node, index)=>/*#__PURE__*/ React.createElement("div", {
            key: `postfix-${index}`,
            className: s['postfix']
        }, node)));
};
BannerLayout.displayName = 'BannerLayout';
export default BannerLayout;

//# sourceMappingURL=BannerLayout.js.map